import { render, staticRenderFns } from "./courseCardsManagement.vue?vue&type=template&id=1532d767&"
import script from "./courseCardsManagement.vue?vue&type=script&lang=js&"
export * from "./courseCardsManagement.vue?vue&type=script&lang=js&"
import style0 from "./courseCardsManagement.vue?vue&type=style&index=0&id=1532d767&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports